/**
 * Route for `gdpr-regional-data-storage-dsr-endpoints-ui-http-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GdprRegionalDataStorageDsrEndpointsUiHttpApiPage } from "../features/gdpr-regional-data-storage-dsr-endpoints-ui-http-api/GdprRegionalDataStorageDsrEndpointsUiHttpApiPage";

export const gdprRegionalDataStorageDsrEndpointsUiHttpApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/gdpr-regional-data-storage-dsr-endpoints-ui-http-api",
	component: GdprRegionalDataStorageDsrEndpointsUiHttpApiPage,
});

export default gdprRegionalDataStorageDsrEndpointsUiHttpApiRoute;
